import TechStackRow from "./TechStackRow";
import useLanguage from "../i18n/useLanguage";
import { useEffect, useRef, useState } from "react";
import { FaPython, FaReact, FaFigma } from "react-icons/fa";
import {
  SiNextdotjs,
  SiGo,
  SiLaravel,
  SiSwift,
  SiFlutter,
  SiKotlin,
  SiAdobephotoshop,
  SiBlender,
} from "react-icons/si";

export default function TechStack() {
  const { t, language } = useLanguage();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="tech"
      className="min-h-screen bg-black text-white flex flex-col items-center justify-center py-20"
    >
      <h2 className="text-6xl font-bold text-amber-300 mb-24 text-center">{t("Key Designs & Technologies")}{" "}</h2>

      <div className="w-full max-w-5xl flex flex-col gap-24 px-6">
        <TechStackRow
          title={language === "id" ? ["Technologies", "Core"] : ["Core", "Technologies"]}
          icons={[FaPython, SiFlutter, SiKotlin, FaReact, SiNextdotjs, SiGo, SiLaravel, SiSwift]}
          isVisible={isVisible}
        />

        <TechStackRow
          title={language === "id" ? ["Designs", "Core"] : ["Core", "Designs"]}
          icons={[FaFigma, SiBlender, SiAdobephotoshop]}
          isVisible={isVisible}
        />
      </div>
    </section>
  );
}
